import { httpReducer } from "../lib/create-action";
import { showFeedImportActionName, episodeFeedImportActionName } from "../actions/feed_import";

const showFeedImport = httpReducer(showFeedImportActionName, {
  isLoading: false,
});

const episodeFeedImport = httpReducer(episodeFeedImportActionName, {
  isLoading: false,
});

export { showFeedImport, episodeFeedImport };
